export default "/assets/images/live-room-screenshot.png?62f249fbf53e07ce89b150eb2dad22af";